import React from "react";

export const RegionalMonitoring = React.lazy(
  () =>
    import("@/features/regional-monitoring/pages/RegionalMonitoringPage.tsx"),
);
